import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./Components/scrollToTop";
import About from "./Pages/about";
import Contact from "./Pages/contact";
import Header from "./Components/header";
import Services from "./Pages/services";
import Blog from "./Pages/blog";
import Home from "./Pages/home";
import JoinUs from "./Pages/joinUs";
import NotFound from "./Pages/notFound";
import Footer from "./Components/footer";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/joinUs" element={<JoinUs />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
